"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
var _Modal = _interopRequireDefault(require("../Modal"));
var _List = _interopRequireDefault(require("../List/List"));
var _currency = require("../../currency");
var _Toggle = _interopRequireDefault(require("../helpers/Toggle"));
var _pricing = require("../../helpers/pricing");
var _Link = _interopRequireDefault(require("../Link/Link"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CardFeeModal = function CardFeeModal(_ref) {
  var amount = _ref.amount;
  var _useContext = (0, _react.useContext)(_currency.CurrencyContext),
    creditCardCharges = _useContext.creditCardCharges,
    currency = _useContext.currency;
  var cardChargesExist = creditCardCharges && Object.values(creditCardCharges).some(function (val) {
    return val > 0;
  });
  if (!cardChargesExist) {
    return null;
  }
  var FALLBACK_CREDIT_CARD_CHARGE = 'fallback_credit_card_charge';
  var allRatesAreSame = Object.values(creditCardCharges).every(function (val) {
    return val === creditCardCharges[FALLBACK_CREDIT_CARD_CHARGE];
  });
  var cardChargeAmountText = amount ? (0, _pricing.formatCurrency)(amount / 100 * creditCardCharges[FALLBACK_CREDIT_CARD_CHARGE] / 100, currency, currency, false) : null;
  var sameFeeItem = {
    title: 'Fee',
    subtitle: 'All cards',
    value: cardChargeAmountText || "".concat(creditCardCharges[FALLBACK_CREDIT_CARD_CHARGE], "%"),
    valueInfo: cardChargeAmountText && "".concat(creditCardCharges[FALLBACK_CREDIT_CARD_CHARGE], "%")
  };
  return /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref2) {
    var on = _ref2.on,
      toggle = _ref2.toggle;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "d8-u-color-primary d8-u-text-semi-bold",
      style: {
        fontWeight: '400'
      },
      text: "Read more",
      icon: "info",
      iconFlip: true,
      buttonType: _constants.BUTTON_TYPES.BARE_PRIMARY,
      buttonSize: _constants.BUTTON_SIZES.SMALL,
      onClick: toggle
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      on: on,
      toggle: toggle
    }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
      heading: "Fees",
      items: allRatesAreSame ? [sameFeeItem] : Object.keys(creditCardCharges).filter(function (c) {
        return c !== FALLBACK_CREDIT_CARD_CHARGE;
      }).map(function (c) {
        var parts = c.split('_');
        var title = parts[parts.length - 1].toUpperCase();
        var subtitle = "".concat(parts[0].charAt(0).toUpperCase()).concat(parts[0].slice(1), " card");
        var cardChargeAmountText = amount ? (0, _pricing.formatCurrency)(amount / 100 * creditCardCharges[c] / 100, currency, currency, false) : null;
        return {
          title: title,
          subtitle: subtitle,
          value: cardChargeAmountText || "".concat(creditCardCharges[c], "%"),
          valueInfo: cardChargeAmountText && "".concat(creditCardCharges[c], "%")
        };
      })
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: "margin-top-md"
    }, "Fees are not applicable for payments made with card issued in the UK. For further details on our Payment Options and Fees head ", /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: "https://www.theyachtweek.com/blog/2023/06/payment-options",
      external: true
    }, "here"))));
  });
};
var _default = exports["default"] = CardFeeModal;